import React, { FunctionComponent, ReactNode } from 'react';
import { ReactComponent as ClosedArrowSvg } from '../../assets/icons/closed-blue-arrow.svg';
import './Accordion.scss';


interface AccordionI {
  name: string,
  info: string,
  className?: string,
  open: boolean,
  setOpen: (i: boolean) => void,
  children: ReactNode | ReactNode[],
}

export const Accordion: FunctionComponent<AccordionI> = (props) => {
  const { name, info, open, setOpen, className, children } = props;

  return (
    <div className={`accordion ${className ? className : ''} ${open ? 'accordion_open' : ''}`}>
      <div className='accordion__header' onClick={() => setOpen(!open)}>
        <div className='accordion__header__title'>
          <ClosedArrowSvg className='accordion__arrow'/>
          {name}
        </div>
        <div className='accordion__header__info' title={info}>{info}</div>
      </div>
      {open && <div className='accordion__children'>{children}</div>}
    </div>
  );
};